import { ModelBase } from 'store/model-base';

export class CmsNowCore extends ModelBase {
    public static storeName: string = 'cmsNowCore';

    public modals: SiteModals;
    public metaData: SiteNowMetaData;
    public footer: SiteFooter;
    public nav: NowSiteNav;
    public icons: CmsIcons;
    public schema: CmsSchema;
    public common: CmsCommon;
}
